module.exports = __webpack_public_path__ + "img/product1.00407991.png";